import { Link } from "react-router";
import type { AdminSessionRow } from "../../lib/admin/types";
import { toDate } from "../../lib/admin/types";
import { formatDuration, formatMode, formatPercentage } from "../../lib/admin/formatters";
import { RelativeTime } from "./RelativeTime";

export function SessionsList({ sessions }: { sessions: AdminSessionRow[] }) {
  if (sessions.length === 0) {
    return (
      <p className="font-serif-italic text-[var(--ink-muted)]">
        Geen sessies — deze gebruiker is nog niet begonnen.
      </p>
    );
  }
  return (
    <>
      <p className="sr-only">
        Lijst van sessies. Elke rij toont modus, tijd, duur, score, percentage en
        resultaat; klik op een rij voor het rapport.
      </p>
      <ul role="list" className="divide-y divide-[var(--border)]">
        {sessions.map((s) => {
          const startedAt = toDate(s.startedAt) ?? new Date(0);
          const finishedAt = toDate(s.finishedAt);
          const score =
            s.totalScore !== null && s.maxScore !== null
              ? `${s.totalScore}/${s.maxScore}`
              : "—";
          const result =
            s.passed === null ? (
              <span className="text-[var(--ink-faint)]">—</span>
            ) : s.passed ? (
              <span className="text-[var(--pass)]">Geslaagd</span>
            ) : (
              <span className="text-[var(--fail)]">Niet gehaald</span>
            );
          const href = `/report/${s.id}?from=admin-user`;
          return (
            <li key={s.id}>
              <Link
                to={href}
                className="grid grid-cols-[1fr_auto_auto] sm:grid-cols-[1fr_auto_auto_auto_auto] items-baseline gap-3 sm:gap-5 py-3 -mx-2 px-2 rounded-md hover:bg-[var(--panel-soft)]/60 focus-visible:bg-[var(--panel-soft)] focus-visible:outline-none transition-colors"
              >
                <span className="text-sm">
                  <span className="text-[var(--ink)] font-medium">
                    {formatMode(s.mode)}
                  </span>
                  <span className="ml-2 text-xs text-[var(--ink-faint)]">
                    <RelativeTime when={startedAt} />
                  </span>
                </span>
                <span className="hidden sm:inline font-mono-badge text-xs text-[var(--ink-muted)]">
                  {formatDuration(startedAt, finishedAt)}
                </span>
                <span className="hidden sm:inline font-mono-badge text-xs text-[var(--ink-muted)] tabular-nums">
                  {score}
                </span>
                <span className="font-mono-badge text-xs text-[var(--ink-muted)] tabular-nums">
                  {formatPercentage(s.percentage)}
                </span>
                <span className="text-xs">{result}</span>
              </Link>
            </li>
          );
        })}
      </ul>
    </>
  );
}
